import { v4 as uuidv4 } from 'uuid';

export default function getUniqueKey(index: number, name: string) {
  if (!name) {
    return index;
  } else {
    return `${index}-${name}-${uuidv4()}`;
  }
}
